<template>
  <!-- 教师画像 -->
  <div class="page">
    <div :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <el-row :gutter="12" class="firstFloor">
        <el-col :span="8">
          <div class="grid-content record">
            <div class="dataSources">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span style="margin-right: 20px">性别分布</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart
                  :refId="'genderChart'"
                  :datas="gender.dataList"
                  :colorName="1"
                  :innerText="'数量'"
                ></circularChart>
              </div>
            </div>

            <div class="picture">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span>年龄分布</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart
                  :refId="'agedistributionChart'"
                  :datas="ageDistribution.dataList"
                  :colorName="1"
                  :innerText="'数量'"
                ></circularChart>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师所在地域分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="width: 100%; height: 730px">
                <distributionCharts
                  :refId="'teachersChart'"
                  :datas="teachers.dataList"
                ></distributionCharts>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师用户历年新增数</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'teacherUsersAddedChart'"
                :datas="teacherUsersAdded.dataList"
                :transverseData="teacherUsersAdded.transverseData"
                :colorList="teacherUsersAdded.colorList"
                :legendList="teacherUsersAdded.legendList"
                :gridWidth="true"
                :innerText="'单位：人'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年教师用户注册情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'monthlyRegistrationChart'"
                :datas="monthlyRegistration.dataList"
                :transverseData="monthlyRegistration.transverseData"
                :colorList="monthlyRegistration.colorList"
                :legendList="monthlyRegistration.legendList"
                :innerText="'单位：人'"
              ></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>主持院校实名教师占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="hostInstitutions.dataList"
                :colorList="hostInstitutions.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师访问时间段分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userAccessChart'"
                :datas="userAccess.dataList"
                :transverseData="userAccess.transverseData"
                :colorList="userAccess.colorList"
                :legendList="userAccess.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第四层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>实名教师无活动占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="inactiveTeachers.dataList"
                :colorList="inactiveTeachers.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年教师访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'monthlyAverageChart'"
                :datas="monthlyAverage.dataList"
                :transverseData="monthlyAverage.transverseData"
                :colorList="monthlyAverage.colorList"
                :legendList="monthlyAverage.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>受教育程度</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'resourcesCitedChart'"
                :datas="eduationDataList"
                :colorName="'2'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师发布课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'citedByCoursesChart'"
                :datas="courseRelease"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师发布资源</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'accessResourcesChart'"
                :datas="resourceRelease"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="sameLayer">
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师发布作业</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'magnitudeChart'"
                :datas="courseWork.dataList"
                :transverseData="courseWork.transverseData"
                :colorList="colorList"
                :innerText="'单位：次'"
              ></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>论坛发布情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'magnitudeChart'"
                :datas="forumRelease.dataList"
                :transverseData="forumRelease.transverseData"
                :colorList="colorList"
                :innerText="'单位：次'"
              ></vcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第五层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="12">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位教师数排名（前10名）</span>
              </div>
              <span
                class="more"
                @click="seeMore(-1, '建设单位教师数排名', participating.headerList)"
              >
                查看更多
                <i class="el-icon-d-arrow-right"></i>
              </span>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'participatingChart'"
                :datas="participating.dataList"
                :transverseData="participating.transverseData"
                :colorList="colorList"
              ></tcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>上传资源数量排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits1.tableList"
                  :headerData="resourceVisits1.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits1.tableList.length >= 6"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(2, '上传资源数量排名(前100名)', resourceVisits1.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第六层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom: 10px">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>布置作业考试次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits2.tableList"
                  :headerData="resourceVisits2.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits2.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(3, '布置作业考试次数排名(前100名)', resourceVisits2.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参与互动次数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits3.tableList"
                  :headerData="resourceVisits3.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits3.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(4, '参与互动次数排名(前100名)', resourceVisits3.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第七层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom: 0px">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>所授课程选课人数排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits4.tableList"
                  :headerData="resourceVisits4.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits4.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(5, '选课人数排名(前100名)', resourceVisits4.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>总访问量排名</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits5.tableList"
                  :headerData="resourceVisits5.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits5.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="seeMore(6, '总访问量排名(前100名)', resourceVisits5.headerList)"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog
      :title="detailsBox.title"
      :visible.sync="detailsBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up distribute"
      append-to-body
      :before-close="handleClose"
    >
      <div class="moreBox">
        <tableList
          :tableData="detailsBox.data.tableList"
          :headerData="detailsBox.data.headerList"
        ></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>

<script>
import distributionCharts from "@/components/chart/distributionCharts.vue"; //地图
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; //横着的柱状图
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; //引入水滴图图表
import meterChart from "@/components/chart/meterChart.vue"; //仪表图

import tableList from "@/components/tableList.vue"; //表格

export default {
  components: {
    distributionCharts,
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    meterChart,
    tableList,
  },
  data() {
    return {
      colorList: [
        "#1BF6F8",
        "#3B86FF",
        "#FA4798",
        "#6FE05F",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      dashboardColor: [
        ["#E67070", "#E10303"],
        ["#ECB853", "#DF9C0D"],
        ["#43CCB3", "#12A888"],
      ], //仪表盘颜色红，黄，绿
      zykId: "",
      // 第一层
      gender: {
        // 性别分布
        dataList: [],
      },
      ageDistribution: {
        // 年龄分布
        dataList: [],
      },
      teachers: {
        //地图
        dataList: [],
      },

      // 第二层
      teacherUsersAdded: {
        //教师用户历年新增数
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      monthlyRegistration: {
        //近一年教师用户注册情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第三层
      hostInstitutions: {
        //主持院校实名教师占比
        dataList: 0,
        colorList: [],
      },
      userAccess: {
        //教师访问时间段分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第四层
      inactiveTeachers: {
        //实名教师无活动占比
        dataList: 0,
        colorList: [],
      },
      monthlyAverage: {
        //近一年教师访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      eduationDataList: [], //受教育程度
      courseRelease:[],//教师发布课程
      resourceRelease:[],// 教师发布资源
      // 教师发布作业
      courseWork: {
        dataList: [],
        transverseData: [],
      },
      // 论坛发布情况
      forumRelease: {
        dataList: [],
        transverseData: [],
      },
      // 第五层
      participating: {
        //建设单位教师数排名（前10名）
        dataList: [],
        transverseData: [],
        tableList: [],
        headerList: [
          {
            name: "序号",
            prop: "index",
          },
          {
            name: "院校名称",
            prop: "name",
          },
          {
            name: "教师数",
            prop: "value",
          },
        ],
      },
      resourceVisits1: {
        tableList: [],
        headerList: [
          {
            name: "序号",
            prop: "index",
          },
          {
            name: "姓名",
            prop: "name",
          },
          {
            name: "院校",
            prop: "school",
          },
          {
            name: "专业",
            prop: "profession",
          },
          {
            name: "上传资源数量",
            prop: "num",
          },
        ],
      },

      // 第六层
      resourceVisits2: {
        tableList: [],
        headerList: [],
      },
      resourceVisits3: {
        tableList: [],
        headerList: [],
      },

      // 第七层
      resourceVisits4: {
        tableList: [],
        headerList: [],
      },
      resourceVisits5: {
        tableList: [],
        headerList: [],
      },

      // 弹窗
      detailsBox: {
        title: "",
        show: false,
        data: {
          tableList: [],
          headerList: [],
        },
      },
    };
  },
  created() {
    this.zykId = sessionStorage.getItem("zykId");
    // 第一层
    this.genderDom();
    this.ageDistributionDom();
    this.teachersDom();

    // // 第二层
    this.teacherUsersAddedDom();
    this.monthlyRegistrationDom();

    // // 第三层
    this.hostInstitutionsDom();
    this.userAccessDom();

    // // 第四层
    this.inactiveTeachersDom();
    this.monthlyAverageDom();

    this.getTeacherEduationEchart();
    this.getTeacherReleaseCourse()
    this.getTeacherReleaseResource()
    this.getCourseWorkCase();
    this.getForumReleaseCase();

    // // 第五层
    this.participatingDom();
    this.resourceVisits1Dom();

    // // 第六层
    this.resourceVisits2Dom();
    this.resourceVisits3Dom();

    // // 第七层
    this.resourceVisits4Dom();
    this.resourceVisits5Dom();
  },
  methods: {
    // 第一层
    // 性别分布
    genderDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherSexEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.gender.dataList = res.data;
          }
        });
    },
    // 年龄分布
    ageDistributionDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherAgeEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var arrList = [];
            for (let i = 0; i < res.data.name.length; i++) {
              arrList.push({
                name: res.data.name[i],
                value: res.data.value[i],
              });
            }
            this.ageDistribution.dataList = arrList;
          }
        });
    },
    // 教师所在地域分布图
    teachersDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherProvinceUsersEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.teachers.dataList = res.data;
          }
        });
    },

    // 第二层
    // 教师用户历年新增数
    teacherUsersAddedDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getUserByYearAddCountEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.teacherUsersAdded.transverseData = res.data.name;
            this.teacherUsersAdded.dataList = res.data.value;
            this.teacherUsersAdded.colorList = this.colorList;
            this.teacherUsersAdded.legendList = [];
          }
        });
    },
    //近一年教师用户注册情况
    monthlyRegistrationDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherByMonthRegisterCountEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.monthlyRegistration.transverseData = res.data.name;
            this.monthlyRegistration.dataList = res.data.value;
            this.monthlyRegistration.colorList = this.colorList;
            this.monthlyRegistration.legendList = [];
          }
        });
    },

    // 第三层
    // 主持院校实名教师占比
    hostInstitutionsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getRealNameTeachersInHostInstitution, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.hostInstitutions.dataList = value;
            if (value >= 90) {
              this.hostInstitutions.colorList = this.dashboardColor[2];
            } else {
              this.hostInstitutions.colorList = this.dashboardColor[0];
            }
          }
        });
    },
    // 教师访问时间段分布
    userAccessDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherActionTimeDistributionEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.userAccess.transverseData = res.data.name;
            this.userAccess.dataList = res.data.value;
            this.userAccess.colorList = this.colorList;
            this.userAccess.legendList = [];
          }
        });
    },

    // 第四层
    // 实名教师无活动占比
    inactiveTeachersDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getProportionOfInactiveTeachers, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.inactiveTeachers.dataList = value;
            if (value >= 10) {
              this.inactiveTeachers.colorList = this.dashboardColor[0];
            } else if (value >= 8 && value < 10) {
              this.inactiveTeachers.colorList = this.dashboardColor[1];
            } else {
              this.inactiveTeachers.colorList = this.dashboardColor[2];
            }
          }
        });
    },
    //近一年教师访问情况
    monthlyAverageDom() {
      this.$axios
        .post(this.$apiurls.teacherPortrait_getTeacherActionApplicationByYearEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.monthlyAverage.transverseData = res.data.name;
            this.monthlyAverage.dataList = res.data.value;
            this.monthlyAverage.colorList = this.colorList;
            this.monthlyAverage.legendList = [];
          }
        });
    },

    // 受教育程度
    getTeacherEduationEchart() {
      this.$axios
        .post(this.$apiurls.getTeacherEduationEchart, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.eduationDataList = res.data;
          }
        });
    },

    // 教师发布课程接口
    getTeacherReleaseCourse(){
      this.$axios
        .post(this.$apiurls.getTeacherReleaseCourse, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data=res.data
            this.courseRelease=[
              {
                name:"个性化课程",
                value:data.personalityNum
              },
              {
                name:"标准化课程",
                value:data.standardNum
              },
            ]
          }
        });
    },

    // 教师发布资源接口
    getTeacherReleaseResource(){
      this.$axios
        .post(this.$apiurls.getTeacherReleaseResource, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data=res.data
            this.resourceRelease= [
            {
              name: "视频",
              value: data.video,
            },
            {
              name: "动画",
              value: data.animation,
            },
            {
              name: "图形图像",
              value: data.graphicImage,
            },
            {
              name: "虚拟仿真",
              value: data.virtualSimulation,
            },
            {
              name: "文本",
              value: data.text,
            },
            {
              name: "微课",
              value: data.smallCourse,
            },
            {
              name: "音频",
              value: data.audio,
            },
            {
              name: "ppt和富媒体",
              value: data.ppt + data.courseWare + data.media,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          }
        });
},

    // 教师发布作业
    getCourseWorkCase() {
      this.$axios
        .post(this.$apiurls.getCourseWorkCase, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.courseWork.dataList = [];
            this.courseWork.transverseData = [];
            for (const key in data) {
              this.courseWork.dataList.push(data[key]);
              this.courseWork.transverseData.push(key);
            }
          }
        });
    },

    // 论坛发布情况
    getForumReleaseCase() {
      this.$axios
        .post(this.$apiurls.getForumReleaseCase, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.chart;
            this.forumRelease.dataList = [];
            this.forumRelease.transverseData = [];
            for (const key in data) {
              this.forumRelease.dataList.push(data[key]);
              this.forumRelease.transverseData.push(key);
            }
          }
        });
    },

    // 第五层
    // 建设单位教师数排名（前10名）
    participatingDom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherCountByConstructionUnitEchart,
          {
            loading: false,
          },
          { timeout: 3 * 60 * 1000 }
        )
        .then((res) => {
          if (res.code === 200) {
            let name = res.data.name;
            this.participating.transverseData = name.slice(0, 10);
            let value = res.data.value;
            this.participating.dataList = value.slice(0, 10);
            let arr = [];
            for (let i = 0; i < name.length; i++) {
              arr.push({
                index: i + 1,
                name: name[i],
                value: value[i],
              });
            }
            this.participating.tableList = arr;
          }
        });
    },
    // 上传资源数量排名
    resourceVisits1Dom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
          {
            limitNum: "7",
            statType: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 7) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits1.tableList = res.data;
          }
        });
    },

    // 第六层访问表格
    resourceVisits2Dom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
          {
            limitNum: "11",
            statType: 3,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits2.tableList = res.data;
            this.resourceVisits2.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "布置作业/考试次数",
                prop: "num",
              },
            ];
          }
        });
    },
    resourceVisits3Dom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
          {
            limitNum: "11",
            statType: 4,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits3.tableList = res.data;
            this.resourceVisits3.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "互动次数",
                prop: "num",
              },
            ];
          }
        });
    },

    // 第七层
    resourceVisits4Dom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
          {
            limitNum: "11",
            statType: 5,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits4.tableList = res.data;
            this.resourceVisits4.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "选课人数",
                prop: "num",
              },
            ];
          }
        });
    },
    resourceVisits5Dom() {
      this.$axios
        .post(
          this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
          {
            limitNum: "11",
            statType: 6,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits5.tableList = res.data;
            this.resourceVisits5.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "姓名",
                prop: "name",
              },
              {
                name: "院校",
                prop: "school",
              },
              {
                name: "专业",
                prop: "profession",
              },
              {
                name: "访问量",
                prop: "num",
              },
            ];
          }
        });
    },

    // 查看更多
    seeMore(index, title, headerList) {
      this.$store.commit("isLoading", true);
      this.detailsBox.data.tableList = [];
      if (index === -1) {
        this.showTable(this.participating.tableList, title, headerList);
      } else
        this.$axios
          .post(
            this.$apiurls.teacherPortrait_getTeacherVisitCountRankByType,
            {
              limitNum: "100",
              statType: index,
            },
            {
              loading: false,
            }
          )
          .then((res) => {
            if (res.code === 200) {
              this.showTable(res.data, title, headerList);
            }
          })
          .catch((_) => {
            this.$store.commit("isLoading", false);
          });
    },
    showTable(data, title, headerList) {
      this.detailsBox.show = true;
      this.detailsBox.data.tableList = data;
      this.detailsBox.data.headerList = headerList;
      this.detailsBox.title = title;
      this.$store.commit("modifyVague", true);
      this.$store.commit("isLoading", false);
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false;
      this.$store.commit("modifyVague", false);
      this.$store.commit("isLoading", false);
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/table.scss" scoped></style>
<style lang="scss" scoped>
/* 第一层 */
.firstFloor {
  height: 796px;
  position: relative;
  margin-bottom: 12px;
}

.firstFloor .el-col-16 {
  height: 100%;
}

.record {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
/* 参建学校分布 */
.dataSources {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

/* 其他建参单位数量 */
.picture {
  position: relative;
  width: 100%;
}

.firstFloor .echartsHeight {
  width: 100%;
  height: 352px;
}

/* 第二层 ,第三层 ,第四层 */
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
}

/* 表格 */
.chart .el-col {
  height: auto;
  position: relative;
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
.more {
  cursor: pointer;
  color: #1bf6f8;
  z-index: 1;
  font-size: 12px;
  padding-right: 10px;
}
</style>
